import * as React from 'react';
import { Review } from '@restworld/utility-types';
import { cn, getTimeDifference } from '@restworld/utils-common';

import { Card } from './card.wrapper';
import { Rating } from '../rating';
import { Heading, Text } from '@restworld/ui-ds-base';

export const CardReview: React.FunctionComponent<Review> = ({ author_name, rating, time, text }) => (
  <CardWrapper>
    <Card variant="primary50">
      <Heading size={5}>{author_name}</Heading>
      <CardBodyWrapper>
        <Rating rating={rating} />
        <Heading as="span" size={5} weight="normal" className="font-light">
          {getTimeDifference(time)}
        </Heading>
      </CardBodyWrapper>
      <Text>{text}</Text>
    </Card>
  </CardWrapper>
);
export default CardReview;
const CardWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('px-2 w-full gap-2 shadow-none', className)} {...props} />
);
const CardBodyWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex gap-2', className)} {...props} />
);
